import React, { useEffect, useState } from "react";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import { Link } from "react-router-dom";
import { apibaseurl } from "../../environment";
import useApi from "../../core/customhook/useApi";

const AppraisalLetter = () => {
  const [documents, setDocuments] = useState([]);
  const formatFinancialYear = (year: number) => {
    const nextYearShort = (year + 1).toString().slice(-2);
    return `${year}-${nextYearShort}`;
  };

  const getCurrentFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const fyStart = month >= 3 ? year : year - 1;
    return formatFinancialYear(fyStart);
  };
  const [finance_year, setFinance_year] = useState(getCurrentFinancialYear());

  const {
    data,
    error,
    loading: apprisalletterloading,
  } = useApi("/api/apprisal-letter", {
    method: "POST",
    autoCall: true,
    payload: {
      financial_year: finance_year,
    },
    dependencies: [finance_year],
  });

  console.log(data);

  useEffect(() => {
    if (data?.success) {
      setDocuments(data?.data);
    }
  }, [data]);

  const handleDownload = async (filePath: string , file_name : string) => {
    try {
      const fileUrl = `${apibaseurl}/uploads/apprisalletters/${filePath}`;
      const fileName = file_name || "downloaded_file";

      const response = await fetch(fileUrl, {
        method: "GET",
        headers: {
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch file");
      }

      // Convert response to blob
      const blob = await response.blob();

      // Create temporary link element
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName; // Suggests file name to browser
      document.body.appendChild(link);
      link.click();

      // Clean up
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
      alert("Error downloading file. Please try again.");
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Breadcrumb */}
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Appraisal Letter</h2>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="#">
                    <i className="ti ti-smart-home" />
                  </Link>
                </li>
                <li className="breadcrumb-item">Administration</li>
                <li className="breadcrumb-item active" aria-current="page">
                  Appraisal Letter
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
            <div className="input-icon w-120 position-relative mb-2">
              <select
                value={finance_year}
                onChange={(e) => setFinance_year(e.target.value)}
                className="form-select"
              >
                {(() => {
                  const today = new Date();

                  const currentYear =
                    today.getMonth() >= 3
                      ? today.getFullYear()
                      : today.getFullYear() - 1;

                  return Array.from({ length: 2 }, (_, i) => {
                    const year = currentYear - i;
                    const nextYearShort = String(year + 1).slice(-2);

                    const financialYear = `${year}-${nextYearShort}`;

                    return (
                      <option key={financialYear} value={financialYear}>
                        {financialYear}
                      </option>
                    );
                  });
                })()}
              </select>
            </div>
            <div className="head-icons ms-2">
              <CollapseHeader />
            </div>
          </div>
        </div>
        {/* /Breadcrumb */}

        {/* Documents Table */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table text-nowrap">
                    <thead>
                      <tr>
                        <th scope="col">Image</th>
                        {/* <th scope="col">Title</th> */}
                        <th scope="col">Financial year</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {documents.length > 0 ? (
                        documents.map((item: any) => (
                          <tr key={item.id}>
                            <td>
                              <a
                                href={`${apibaseurl}/uploads/apprisalletters/${item.file_path}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  src="https://cdn-icons-png.flaticon.com/512/337/337946.png"
                                  alt="pdf"
                                  style={{ height: "70px", cursor: "pointer" }}
                                />
                              </a>
                            </td>

                            {/* <td>{item.title}</td> */}

                            <td>{item.financial_year}</td>

                            <td>
                              <div className="hstack gap-2 fs-15">
                                <a
                                  href="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleDownload(item.file_path , item.file_name);
                                  }}
                                  className="btn btn-icon btn-sm btn-info d-flex align-items-center justify-content-center"
                                  style={{ width: "30px", height: "30px" }}
                                >
                                  <i className="feather-download" />
                                </a>

                                <a
                                  href={`${apibaseurl}/uploads/apprisalletters/${item.file_path}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="btn btn-icon btn-sm btn-primary d-flex align-items-center justify-content-center"
                                  style={{ width: "30px", height: "30px" }}
                                >
                                  <i className="feather-eye" />
                                </a>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={4} className="text-center py-4">
                            No Appraisal Letter Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
        <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
      </div>
    </div>
  );
};

export default AppraisalLetter;
